import React, { useEffect, useMemo, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import PhoneIcon from "@mui/icons-material/Phone";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import { CustomerViewDetailsViewEmailInfoProps } from "./customer-view-details-view-email-info.props";
import "./customer-view-details-view-email-info.scss";
import { useSetLoading } from "../../../../../../common/hooks/appearance";
import { formatDate } from "../../../../../../utils/utils";
import { AlertComponent, ConfirmationPopup } from "../../../../../../common/components";
import ConfirmInfo from "../../../../../../assets/icons/confirm-info.svg";
import DeleteIcon from "../../../../../../assets/icons/archive-icon.svg";
import DataTable from "../../../../../campaign/campiagn-view/campaign-view-details/campaign-view-details-view/campaign-view-details-view-activities-info/task-table/task-table";
import { IconButton } from "@mui/material";
import ComposeEmailDialog from "./compose-email/compose-email";
import { deleteEmail, getEmails, getLetters, deleteLetter } from "../../../../../../api/campaign";
import { getCustomerDetails } from "../../../../../../api/customer";
import SelectTemplateOption from "../../../../../leads/lead-view/lead-view-details/lead-view-details-view/lead-view-details-view-email-info/select-template-option-dropdown";
import { emailComposeOptions, letterComposeOptions } from "../../../../../leads/lead-filter/lead-filter.constant";
import { getEmailLetterTemplates, getTemplateHeaderOrFooter } from "../../../../../../api/email-letter-templates";
import TemplateListPopup from "../../../../../../common/components/templates-list-popup/template-list-popup";
import MoreVertIcon from "@mui/icons-material/MoreVert"; 
import ActionsMenu from "../../../../../../common/components/mui-table/actions-menu";
import { useResourcePermissions } from "../../../../../../common/hooks/resource-permissions";
import MODULES from "../../../../../../constants/modules";
import CloseIcon from "@mui/icons-material/Close";
import NewEmailTemplateEditor from "../../../../../surveys/email-templates/new-email-template-editor/new-email-template-editor";
import PrintablePDFPreview from "../../../../../surveys/email-templates/printable-pdf-preview";
import EmailSetUpBanner from "../../../../../../common/components/email-setup-required-banner/email-setup-banner";
import { useLogin } from "../../../../../../common/hooks/useUser";

interface toggleEditor {
  isOpen: boolean;
  mode: "view" | "edit" | "new";
  template: any;
}

const CustomerViewDetailsViewEmailInfo: React.FC<
  CustomerViewDetailsViewEmailInfoProps
> = (props: any) => {
  const { allCustomerData, disableEdit,customerDetails } = props;
  const [indexValue, setIndexValue] = React.useState(0);
   const [isArchivePopupOpen, setIsArchivePopupOpen] = useState(false);
  const [emailToDelete, setEmailToDelete] = useState<any>(null);
  const [isComposeOpen, setIsComposeOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState<"success" | "error">("success");
  const [loading, setLoading] = useState(false);
  const [emails, setEmails] = useState<any>();
const [letters, setLetters] = useState<any>([]);
  const [emailsCount, setEmailsCount] = useState(0);
  const [lettersCount, setLettersCount] = useState(0);
  const [activeTab, setActiveTab] = useState("Emails");
  const [selectedOption, setSelectedOption] = useState("");
  const [isTemplateListOpen, setIsTemplateListOpen] = useState(false);
  const TAB_OPTIONS = [
    { label: "Emails", countKey: "emailsCount" },
    { label: "Letters", countKey: "lettersCount" },
  ];
  const [templates, setTemplates] = useState<any[]>([]);
  const [selectedTemplateData, setSelectedTemplateData] = useState<any>(null);
  const [templateMetaData, setTemplateMetaData] = useState<any>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [menuRow, setMenuRow] = useState<any>(null);
  const { canRead, canWrite, canDelete } = useResourcePermissions(MODULES.LEAD_DETAILS);
  const [isLetterComposeOpen, setIsLetterComposeOpen] = useState(false);
  const [toggleEditor, setToggleEditor] = useState<toggleEditor>({
    isOpen: false,
    mode: "view",
    template: null,
  });
  const [letterToDelete, setLetterToDelete] = useState<any>(null);
 const [letterAlertMessage, setLetterAlertMessage] = useState<{
     open: boolean;
     message: string;
     type: "success" | "error";
   }>({
     open: false,
     message: "",
     type: "success",
   });
  const [isPrintPreviewOpen, setIsPrintPreviewOpen] = useState<boolean>(false);
  const [letterTemplatePdfUrl, setLetterTemplatePdfUrl] = useState<string>("");
  const loginDetails = useLogin();
  const isEmailConfigured = loginDetails?.isEmailConfigured;

  const handleAlertClose = () => {
    setAlertOpen(false);
    setLetterAlertMessage({
      open: false,
      message: "",
      type: "success",
    });
  };
  const handleDeleteEmail = (email: any) => {
    setEmailToDelete(email);
    setIsArchivePopupOpen(true);
  };
  const handleEmailSuccess = () => {
    setAlertMessage("Email Sent Succeessfully.");
    setAlertType("success");
    setAlertOpen(true);
    setIsComposeOpen(false);
    setSelectedTemplateData(null);
    setSelectedOption('');
    fetchEmails();
  };
  const emailColumns = [
    {
      key: "subject",
      label: "Subject",
      render: (email: any) => email.subject,
    },
    {
      key: "date",
      label: "Date",
      render: (email: any) => formatDate(email.created_at),
    },
    {
      key: "sentBy",
      label: "Sent By",
      render: (email: any) => {
        const first = email.createdBy?.first_name || '';
        const last = email.createdBy?.last_name || '';

        if (first && last) return `${first} ${last}`;
        if (first) return first;
        if (last) return last;
        return '-';
      },
    },
    {
      key: "status",
      label: "Status",
      render: (email: any) => (email.status ? "Sent" : "Failed"),
    },
  ];
  const confirmDeleteEmail = async () => {
    if (!emailToDelete) return;
    setLoading(true);
    try {
      await deleteEmail(emailToDelete.id);
      setAlertMessage("Email archived successfully.");
      setAlertType("success");
      setAlertOpen(true);
      fetchEmails();
    } catch (error) {
      setAlertMessage("Failed to archive Email.");
      setAlertType("error");
      setAlertOpen(true);
    } finally {
      setIsArchivePopupOpen(false);
      setEmailToDelete(null);
      setLoading(false);
    }
  };
  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    // setIndexValue(newValue);
    setActiveTab(newValue);
    setSelectedTemplateData(null);
    setSelectedOption('');
  };
  const fetchEmails = async () => {
    try {
      // Replace this with actual API call to fetch emails
      const response = await getEmails({ customerId:customerDetails.id });
      setEmails(response.data.data.data);
      setEmailsCount(response.data.data.count);
    } catch (error) {
      console.error("Failed to fetch emails:", error);
    }
  };
  const fetchLetters = async () => {
      try {
        const response = await getLetters({ customerId: customerDetails.id });
        setLetters(response.data.data.data);
        setLettersCount(response.data.data.count);
      } catch (error) {
        console.error("Failed to fetch letters:", error);
      }
  };
    
  useEffect(() => {
    if (customerDetails?.id) {
      fetchEmails();
      fetchLetters();
    }
  }, [customerDetails?.id]);
  const handleOptionChange = (e: any) => {
    setSelectedOption(e.target.value);
    if (e.target.value === "Compose New Mail") {
      setIsComposeOpen(true);
    }
    if (e.target.value === "Select from Templates") {
      // Open the template list popup
      setIsComposeOpen(false);
      setIsTemplateListOpen(true);
    }
    if (e.target.value === "Compose New Letter") {
      setIsLetterComposeOpen(true);
      setToggleEditor({
        isOpen: true,
        mode: "new",
        template: null,
      });
    }
  }
  
    const fetchEmailTemplates = async (
      search: string = "",
      filters: any = {}
    ) => {
      setLoading(true);
      try {
        const params: any = {
          fetchAll: true,
        };
        if (filters?.folderId) {
          if (filters.folderId !== "all" && filters.folderId !== "notInFolder") {
            params.folderId = Number(filters.folderId);
          }
          if(filters.folderId === "notInFolder") {
            params.notInFolder = true;
          }
        }
        if (search) {
          params.searchText = search;
        }
        params.templateType = activeTab === "Emails" ? "Email" : "Letter";
        const response = await getEmailLetterTemplates(params);
        setTemplates(response.data.data.result);
        setTimeout(() => setLoading(false), 1000);
      } catch (error: any) {
        console.error("Error fetching email templates:", error);
        setAlertMessage(
          error?.response?.data?.message || "Failed to fetch email templates."
        );
        setAlertType("error");
        setAlertOpen(true);
        setLoading(false);
      }
    };
  
    const fetchTemplateHeaderFooter = async () => {
       try {
         const headerResponse = await getTemplateHeaderOrFooter();
         if(headerResponse?.data?.data)
           setTemplateMetaData(headerResponse.data.data);
       } catch (error:any) {
         console.error("Error fetching template header, footer:", error?.response?.data?.message);
         setAlertMessage(error?.response?.data?.message || "Failed to fetch template header, footer.");
         setAlertType("error");
         setAlertOpen(true);
       }
     }; 
  
    useEffect(() => {
      fetchEmailTemplates();
      if(activeTab === "Emails") {
        fetchTemplateHeaderFooter();
      } 
    }, [activeTab]);
  
    const handleTemplateSelect = () => {
      if(activeTab === "Emails") {
        setIsComposeOpen(true);
        setIsTemplateListOpen(false);
      }
      if (activeTab === "Letters") {
        setIsLetterComposeOpen(true);
        setIsTemplateListOpen(false);
        setToggleEditor({
          isOpen: true,
          mode: "edit",
          template: selectedTemplateData,
        });
      }
    }

  const handleLetterClick = (letter: any) => {
    // Handle letter click logic here
    const updatedLetter = {
      ...letter,
      letterId: letter.id,
    };
    setSelectedTemplateData(updatedLetter);
    setIsLetterComposeOpen(true);
    setToggleEditor({
      isOpen: true,
      mode: "edit",
      template: updatedLetter,
    });
  
  };
  
    const letterColumns = [
      {
        key: "name",
        label: "Letter Name",
        render: (letter: any) => letter.name || "-",
        onCellClick: (letter: any) => {
          // Only name click triggers it
          handleLetterClick(letter);
        },
        
      },
      {
        key: "description",
        label: "Description",
        render: (letter: any) => letter.subject || "-",
      },
      {
        key: "lastEdited",
        label: "Last Edited Date",
        render: (letter: any) => formatDate(letter.updated_at),
      },
    ];
  
    const handleMenuClick = (event: React.MouseEvent<HTMLElement>, row: any) => {
        setAnchorEl(event.currentTarget);
        setMenuRow(row);
      setLetterTemplatePdfUrl(row?.printFileUrl || "");
    };
    const handleClose = () => {
      setAnchorEl(null);
      setMenuRow(null);
    };
  
    const handleAction = (actionType: string, id: number) => {
      if(actionType === "Print") {
        setIsPrintPreviewOpen(true);
        // Implement print functionality here
      }
      if (actionType === "Download") {
        handleDownloadLetter(menuRow);
      }
    }
  
    const handleMenuOptionClick = (option: any) => {
      if (handleAction) handleAction(option?.label, menuRow?.id);
      handleClose();
    };
  
    const getActionTypes = (row: any) => {
      return [
        {
          label: "Print",
          value: "Print",
          id: 1,
          disabled: !canWrite,
        },
        {
          label: "Download",
          value: "Download",
          id: 2,
          disabled: !canWrite,
        },
      ];
    }
  
  const handleLetterComposeModelClose = () => {
      setIsLetterComposeOpen(false);
      setSelectedOption('');
      setSelectedTemplateData(null);
    };
  
    const handleOnCloseEditor = () => {
      setToggleEditor({
        isOpen: false,
        mode: "view",
        template: null,
      });
      handleLetterComposeModelClose();
    };
  
    const handleDeleteLetter = (letter: any) => {
      setLetterToDelete(letter);
      setIsArchivePopupOpen(true);
    };
  
    const confirmDeleteLetter = async () => {
      if (!letterToDelete) return;
      setLoading(true);
      try {
        await deleteLetter(letterToDelete.id);
        setAlertMessage("Letter archived successfully.");
        setAlertType("success");
        setAlertOpen(true);
        fetchLetters();
      } catch (error) {
        setAlertMessage("Failed to archive Letter.");
        setAlertType("error");
        setAlertOpen(true);
      } finally {
        setIsArchivePopupOpen(false);
        setEmailToDelete(null);
        setLoading(false);
      }
    };
    const handleLetterSaveSuccess = () => {
       fetchLetters()
    }
  
    const handleDownloadLetter = (item:any) => {
      const fileUrl = item?.downloadFileUrl || '';
      const fileName = item?.name || "Letter";
      if (fileUrl) {
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
      } else {
        console.warn("No file URL found to download.");
      }
    };
  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);

  return (
    <div className="customer-view-details-view-email-info">
      <div className="customer-view-details-view-email-info-header">
        <div className="customer-view-details-view-email-info-header-text">
          Communications
        </div>
        <div className="select-template-option-dropdown-wrapper">
          <SelectTemplateOption
            selectedOption={selectedOption}
            handleChange={handleOptionChange}
            disabled={!canWrite || !isEmailConfigured}
            placeholder={`${activeTab === "Emails" ? "Compose Email" : "Compose Letter"}`}
            options={activeTab === "Emails" ? emailComposeOptions : letterComposeOptions}
           
          />
        </div>
      </div>
      {!isEmailConfigured && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            padding:"0px 16px 0px 16px",
          }}
        >
          <EmailSetUpBanner />
        </div>
      )}
      <div className="customer-view-details-view-email-info-tab-section">
        <Box>
          <Tabs
            value={activeTab}
            onChange={(e, newValue) => {
              handleTabChange(e, newValue);
            }}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            className="mui-tabs-container"
            sx={{
              '& .MuiTabs-indicator': {
                backgroundColor: '#887952',
              },
            }}
          >
            {TAB_OPTIONS.map((tab) => {
              const count =
                tab.label === "Emails"
                  ? emailsCount
                  : lettersCount
              return (
                <Tab
                  key={tab.label}
                  sx={{
                    "&.Mui-selected": {
                      color: "#212121",
                    },
                    textTransform: "none",
                  }}
                  label={
                    <div className="mui-tab-label">
                      {tab.label} <span className="tab-count">{count}</span>
                    </div>
                  }
                  value={tab.label}
                />
              );
            })}
          </Tabs>
        </Box>
      </div>
      <div className="customer-view-details-view-open-activities-info-content">
        {activeTab === "Emails" &&
          <>
            {emails && emails.length > 0 ? (
              <DataTable
                columns={emailColumns}
                data={emails}
                rowActions={(email) => (
                  <div style={{ display: "flex" }}>
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteEmail(email);
                      }}
                      className="icon-button"
                    >
                      <img src={DeleteIcon} alt="archive" className="img-icon" />
                    </IconButton>
                  </div>
                )}
              />
            ) : (
              <div className="customer-view-details-view-email-info-no-data">
                No Record Found
              </div>
            )}
          </>}
        {activeTab === "Letters" &&
          <>
            {letters && letters.length > 0 ? (
              <>
                <DataTable
                  columns={letterColumns}
                  data={letters}
                  rowActions={(letter) => (
                    <div style={{ display: "flex" }}>

                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteLetter(letter);
                        }}
                        className="icon-button"
                     
                      >
                        <img src={DeleteIcon} alt="archive" className="img-icon" />
                      </IconButton>

                      <IconButton
                        className="icon-button"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleMenuClick(e, letter)
                        }}
                      //  disabled={disableEditField()}
                      >
                        <MoreVertIcon />
                      </IconButton>
                    </div>
                  )}
                />
                <ActionsMenu
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  onOptionClick={handleMenuOptionClick}
                  options={getActionTypes(
                    menuRow
                  )}
                  width="170px"
                />
              </>
            ) : (
              <div className="customer-view-details-view-email-info-no-data">
                No Record Found
              </div>
            )}
          </>
        }
      </div>
      <ComposeEmailDialog
        open={isComposeOpen}
        onClose={() => {
          setIsComposeOpen(false)
          setSelectedTemplateData(null);
          setSelectedOption('');
        }}
        customerDetails={customerDetails}
        onSuccess={handleEmailSuccess}
        templateData={selectedTemplateData}
        templateMetaData={templateMetaData}
        setSelectedTemplateData={setSelectedTemplateData}
      />

      <div className="mark-completed">
        <ConfirmationPopup
          open={isArchivePopupOpen}
          onCancel={() => {
            setIsArchivePopupOpen(false);
            setEmailToDelete(null);
            setLetterToDelete(null);
          }}
          onOkay={
            activeTab === 'Emails'
              ? confirmDeleteEmail
              : confirmDeleteLetter
          }
          title={`Archive ${activeTab === 'Emails' ? 'Email' : 'Letter'}`}
          note={
            activeTab === 'Emails'
              ? (emailToDelete
                ? "Are you sure you want to archive the Email?"
                : "Are you sure you want to archive this Email?")
              : (letterToDelete
                ? "Are you sure you want to archive the Letter?"
                : "Are you sure you want to archive this Letter?")
          }
          buttonText="Archive"
        />
      </div>
      <TemplateListPopup
          open={isTemplateListOpen}
          onClose={() => {
            setIsTemplateListOpen(false)
            setSelectedOption('')
          }}
          title={`Existing ${activeTab === 'Emails' ? 'Email' : 'Letter'} Templates`}
          // fetchTemplates={fetchEmailTemplates}
          templates={templates}
          selectedTemplateData={selectedTemplateData}
          setSelectedTemplateData={setSelectedTemplateData}
          onSelect={() => {handleTemplateSelect()}}
      />

      {isLetterComposeOpen &&
        <div className="modal-overlay">
          <button className="modal-overlay-close-button" onClick={handleLetterComposeModelClose}>
            <CloseIcon sx={{ fontSize: "15px" }} />
          </button>
          <div className="modal-content">
            <NewEmailTemplateEditor
              onClose={handleOnCloseEditor}
              setAlertMessage={setLetterAlertMessage}
              toggleEditor={toggleEditor}
              setToggleEditor={setToggleEditor}
              setIsLoading={setLoading}
              templateType="Letter"
              doReplaceMergeFields={true}
              personDetails={customerDetails}
              fieldName={MODULES.CUSTOMER_PROFILE}
              handleLetterSaveSuccess={handleLetterSaveSuccess}
              setLetterTemplatePdfUrl={setLetterTemplatePdfUrl}
              setIsLetterPrintPreviewOpen={setIsPrintPreviewOpen}
            />
          </div>
        </div>}
      {isPrintPreviewOpen && (
        <div className="modal-overlay">
          <button className="modal-overlay-close-button"
            onClick={() => {
              setIsPrintPreviewOpen(false)
              setLetterTemplatePdfUrl("");
            }}>
            <CloseIcon sx={{ fontSize: "15px" }} />
          </button>
          <div className="modal-content">
            <PrintablePDFPreview
              pdfUrl={`${letterTemplatePdfUrl}`}
            />
          </div>
        </div>
      )}
      <AlertComponent
          message={letterAlertMessage?.message ? letterAlertMessage.message : alertMessage }
          type={ letterAlertMessage?.message ? letterAlertMessage.type : alertType}
          open={ letterAlertMessage?.message ? letterAlertMessage.open : alertOpen}
          onClose={handleAlertClose}
        />
    </div>
  );
};

export default CustomerViewDetailsViewEmailInfo;
